module.exports = __webpack_public_path__ + "static/media/23-mobile.0ea75c12.jpg";